import SignInContent from './SignInContent';
import { AuthMarketingLeftColumn } from '../components/AuthMarketingShell';

/**
 * SignIn Page Component
 *
 * Route: /signin
 * Production (with dashboard base): /dashboard/signin
 */
function SignInPage() {
  const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

  const hasValidKey =
    publishableKey &&
    publishableKey !== 'YOUR_CLERK_PUBLISHABLE_KEY_HERE' &&
    publishableKey.trim() !== '';

  if (!hasValidKey) {
    return (
      <AuthMarketingLeftColumn className="flex min-h-0 flex-1 w-full items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <div className="rounded-lg border-2 border-dashed p-6 text-center" style={{ borderColor: '#E0D9CC', backgroundColor: '#FCFBF8' }}>
            <div className="mb-2 text-sm font-semibold" style={{ color: '#3A3429' }}>
              🔧 Development Mode
            </div>
            <p className="text-xs" style={{ color: '#6B6458' }}>
              Clerk authentication is not configured. To enable authentication, add your Clerk publishable key to{' '}
              <code className="px-1 rounded" style={{ backgroundColor: '#F0ECE4' }}>
                VITE_CLERK_PUBLISHABLE_KEY
              </code>{' '}
              in{' '}
              <code className="px-1 rounded" style={{ backgroundColor: '#F0ECE4' }}>
                .env-cmdrc.json
              </code>
              .
            </p>
            <p className="mt-2 text-xs" style={{ color: '#9A9285' }}>
              The UI structure is visible for frontend development. Authentication will work once the key is configured.
            </p>
          </div>
        </div>
      </AuthMarketingLeftColumn>
    );
  }

  return <SignInContent hasValidKey={hasValidKey} />;
}

export default SignInPage;
